import axios from 'axios';
import {formatTimeToStr} from './date.js';

const utils = {
  hasPermission(permissions, permission) {
    // 这里应该直接从localstore 中取,不经过 vuex
    return permissions.indexOf(permission) > -1
  },
  axiosMethods: (config) => {
    axios({
      method: config.method,
      url: config.url,
      params: config.params ? config.params : null,
      data: config.data ? config.data : null,
      responseType: config.responseType ? config.responseType : 'json',
      withCredentials: true
    }).then(config.callback).catch(config.catch ? config.catch : () => {
    })
  },
  dateFormat: (time, str) => {
    if (time != null && time != "") {
      var date = new Date(time);
      return formatTimeToStr(date, str ? str : "yyyy-MM-dd");
    } else {
      return "";
    }
  },
  /**
   * 获取当前日期一周
   * @param date
   * @returns {any[]}
   */
  getWeekStartAndEnd(date) {
    //起止日期数组
    var startStop = new Array();
    //一天的毫秒数
    var millisecond = 1000 * 60 * 60 * 24;
    //获取当前时间
    var currentDate = date;
    //相对于当前日期AddWeekCount个周的日期
    //返回date是一周中的某一天
    var week = currentDate.getDay();
    //减去的天数
    var minusDay = week != 0 ? week - 1 : 6;
    //获得当前周的第一天
    var currentWeekFirstDay = new Date(currentDate.getTime() - (millisecond * minusDay));
    //获得当前周的最后一天
    var currentWeekLastDay = new Date(currentWeekFirstDay.getTime() + (millisecond * 6));
    //添加至数组
    startStop.push(currentWeekFirstDay);
    startStop.push(currentWeekLastDay);
    return startStop;
  },
  /**
   * 获取当前日期月
   * @param date
   * @returns {any[]}
   */
  getMonthStartAndEnd(date) {
    //起止日期数组
    var startStop = new Array();
    //一天的毫秒数
    var millisecond = 1000 * 60 * 60 * 24;
    //获取当前时间
    var currentDate = date;
    currentDate.setDate(1);

    var nextDate = new Date();
    var nextMonth = currentDate.getMonth() + 1;
    if (nextMonth <= 11) {
      nextDate.setMonth(nextMonth);
    } else {
      nextDate.setMonth(0);
      nextDate.setFullYear(currentDate.getFullYear() + 1)
    }
    nextDate.setDate(1);

    var currentMonthFirstDay = currentDate;
    var currentMonthLastDay = new Date(nextDate.getTime() - millisecond);

    //添加至数组
    startStop.push(currentMonthFirstDay);
    startStop.push(currentMonthLastDay);
    //返回
    return startStop;
  },
  errCoode2Msg(errcode) {
    errcode = Number(errcode);
    let $msg = '错误状态:' + errcode;
    switch (errcode) {
      case -1:
        $msg = '系统繁忙，此时请开发者稍候再试';
        break;
      case 40073:
        $msg = '不合法的 cardid';
        break;
      case 40009:
        $msg = '图片文件超长';
        break;
      case 40013:
        $msg = '不合法的Appid，请开发者检查AppID的正确性';
        break;
      case 40053:
        $msg = '不合法的actioninfo';
        break;
      case 40071:
        $msg = '不合法的卡券类型';
        break;
      case 40072:
        $msg = '不合法的编码方式';
        break;
      case 40078:
        $msg = '不合法的卡券状态';
        break;
      case 40079:
        $msg = '不合法的时间';
        break;
      case 40080:
        $msg = '不合法的CardExt';
        break;
      case 40099:
        $msg = '卡券已被核销';
        break;
      case 40100:
        $msg = '不合法的时间区间';
        break;
      case 40116:
        $msg = '不合法的Code码';
        break;
      case 40122:
        $msg = '不合法的库存数量';
        break;
      case 40124:
        $msg = '会员卡设置查过限制的 custom_field字段';
        break;
      case 40127:
        $msg = '卡券被用户删除或转赠中';
        break;
      case 41012:
        $msg = '缺少cardid参数';
        break;
      case 45030:
        $msg = '该cardid无接口权限';
        break;
      case 45031:
        $msg = '库存为0';
        break;
      case 45033:
        $msg = '用户领取次数超过限制get_limit';
        break;
      case 41011:
        $msg = '缺少必填字段';
        break;
      case 45021:
        $msg = '字段超过长度限制，请参考相应接口的字段说明';
        break;
      case 40056:
        $msg = '不合法的Code码';
        break;
      case 43009:
        $msg = '自定义SN权限，请前往公众平台申请';
        break;
      case 43010:
        $msg = '无储值权限，请前往公众平台申请';
        break;
      case 40001:
        $msg = '获取access_token时AppSecret错误';
        break;
      case 40002:
        $msg = '不合法的凭证类型';
        break;
      case 40003:
        $msg = '不合法的OpenId';
        break;
      case 40004:
        $msg = '不合法的媒体文件类型';
        break;
      case 40005:
        $msg = '不合法的文件类型';
        break;
      case 40006:
        $msg = '不合法的文件大小';
        break;
      case 40007:
        $msg = '不合法的媒体文件id';
        break;
      case 40008:
        $msg = '不合法的消息类型';
        break;
      case 40009:
        $msg = '不合法的图片文件大小';
        break;
      case 40010:
        $msg = '不合法的语音文件大小';
        break;
      case 40011:
        $msg = '不合法的视频文件大小';
        break;
      case 40012:
        $msg = '不合法的缩略图文件大小';
        break;
      case 40013:
        $msg = '不合法的AppID';
        break;
      case 40014:
        $msg = '不合法的access_token';
        break;
      case 40015:
        $msg = '不合法的菜单类型';
        break;
      case 40016:
        $msg = '不合法的按钮个数';
        break;
      case 40017:
        $msg = '不合法的按钮个数';
        break;
      case 40018:
        $msg = '不合法的按钮名字长度';
        break;
      case 40019:
        $msg = '不合法的按钮KEY长度';
        break;
      case 40020:
        $msg = '不合法的按钮URL长度';
        break;
      case 40021:
        $msg = '不合法的菜单版本号';
        break;
      case 40022:
        $msg = '不合法的子菜单级数';
        break;
      case 40023:
        $msg = '不合法的子菜单按钮个数';
        break;
      case 40024:
        $msg = '不合法的子菜单按钮类型';
        break;
      case 40025:
        $msg = '不合法的子菜单按钮名字长度';
        break;
      case 40026:
        $msg = '不合法的子菜单按钮KEY长度';
        break;
      case 40027:
        $msg = '不合法的子菜单按钮URL长度';
        break;
      case 40028:
        $msg = '不合法的自定义菜单使用用户';
        break;
      case 40029:
        $msg = '不合法的oauth_code';
        break;
      case 40030:
        $msg = '不合法的refresh_token';
        break;
      case 40031:
        $msg = '不合法的openid列表';
        break;
      case 40032:
        $msg = '不合法的openid列表长度';
        break;
      case 40033:
        $msg = '不合法的请求字符，不能包含\\uxxxx格式的字符';
        break;
      case 40035:
        $msg = '不合法的参数';
        break;
      case 40038:
        $msg = '不合法的请求格式';
        break;
      case 40039:
        $msg = '不合法的URL长度';
        break;
      case 40050:
        $msg = '不合法的分组id';
        break;
      case 40051:
        $msg = '分组名字不合法';
        break;
      case 40097:
        $msg = '参数不正确，请参考字段要求检查json 字段';
        break;
      case 65104:
        $msg = '门店的类型不合法，必须严格按照附表的分类填写';
        break;
      case 65105:
        $msg = '图片url 不合法，必须使用接口1 的图片上传接口所获取的url';
        break;
      case 65106:
        $msg = '门店状态必须未审核通过';
        break;
      case 65107:
        $msg = '扩展字段为不允许修改的状态';
        break;
      case 65109:
        $msg = '门店名为空';
        break;
      case 65110:
        $msg = '门店所在详细街道地址为空';
        break;
      case 65111:
        $msg = '门店的电话为空';
        break;
      case 65112:
        $msg = '门店所在的城市为空';
        break;
      case 65113:
        $msg = '门店所在的省份为空';
        break;
      case 65114:
        $msg = '图片列表为空';
        break;
      case 65115:
        $msg = 'poi_id 不正确';
        break;
      case 40117:
        $msg = '分组名字不合法';
        break;
      case 40118:
        $msg = 'media_id大小不合法';
        break;
      case 40119:
        $msg = 'button类型错误';
        break;
      case 40120:
        $msg = 'button类型错误';
        break;
      case 40121:
        $msg = '不合法的media_id类型';
        break;
      case 40132:
        $msg = '微信号不合法';
        break;
      case 40137:
        $msg = '不支持的图片格式';
        break;
      case 40155:
        $msg = '请勿添加其他公众号的主页链接';
        break;
      case 41001:
        $msg = '缺少access_token参数';
        break;
      case 41002:
        $msg = '缺少appid参数';
        break;
      case 41003:
        $msg = '缺少refresh_token参数';
        break;
      case 41004:
        $msg = '缺少secret参数';
        break;
      case 41005:
        $msg = '缺少多媒体文件数据';
        break;
      case 41006:
        $msg = '缺少media_id参数';
        break;
      case 41007:
        $msg = '缺少子菜单数据';
        break;
      case 41008:
        $msg = '缺少oauth code';
        break;
      case 41009:
        $msg = '缺少openid';
        break;
      case 42001:
        $msg = 'access_token超时';
        break;
      case 42002:
        $msg = 'refresh_token超时';
        break;
      case 42003:
        $msg = 'oauth_code超时';
        break;
      case 42007:
        $msg = '用户需要重新授权';
        break;
      case 43001:
        $msg = '需要GET请求';
        break;
      case 43002:
        $msg = '需要POST请求';
        break;
      case 43003:
        $msg = '需要HTTPS请求';
        break;
      case 43004:
        $msg = '需要接收者关注';
        break;
      case 43005:
        $msg = '需要好友关系';
        break;
      case 43019:
        $msg = '需要将接收者从黑名单中移除';
        break;
      case 44001:
        $msg = '多媒体文件为空';
        break;
      case 44002:
        $msg = 'POST的数据包为空';
        break;
      case 44003:
        $msg = '图文消息内容为空';
        break;
      case 44004:
        $msg = '文本消息内容为空';
        break;
      case 45001:
        $msg = '多媒体文件大小超过限制';
        break;
      case 45002:
        $msg = '消息内容超过限制';
        break;
      case 45003:
        $msg = '标题字段超过限制';
        break;
      case 45004:
        $msg = '描述字段超过限制';
        break;
      case 45005:
        $msg = '链接字段超过限制';
        break;
      case 45006:
        $msg = '图片链接字段超过限制';
        break;
      case 45007:
        $msg = '语音播放时间超过限制';
        break;
      case 45008:
        $msg = '图文消息超过限制';
        break;
      case 45009:
        $msg = '接口调用超过限制';
        break;
      case 45010:
        $msg = '创建菜单个数超过限制';
        break;
      case 45011:
        $msg = 'API调用太频繁，请稍候再试';
        break;
      case 45015:
        $msg = '回复时间超过限制';
        break;
      case 45016:
        $msg = '系统分组，不允许修改';
        break;
      case 45017:
        $msg = '分组名字过长';
        break;
      case 45018:
        $msg = '分组数量超过上限';
        break;
      case 45047:
        $msg = '客服接口下行条数超过上限';
        break;
      case 46001:
        $msg = '不存在媒体数据';
        break;
      case 46002:
        $msg = '不存在的菜单版本';
        break;
      case 46003:
        $msg = '不存在的菜单数据';
        break;
      case 46004:
        $msg = '不存在的用户';
        break;
      case 47001:
        $msg = '解析JSON/XML内容错误';
        break;
      case 48001:
        $msg = 'api功能未授权';
        break;
      case 48002:
        $msg = '粉丝拒收消息';
        break;
      case 48004:
        $msg = 'api接口被封禁，请登录mp.weixin.qq.com查看详情';
        break;
      case 48005:
        $msg = 'api禁止删除被自动回复和自定义菜单引用的素材';
        break;
      case 48006:
        $msg = 'api禁止清零调用次数，因为清零次数达到上限';
        break;
      case 50001:
        $msg = '用户未授权该api';
        break;
      case 50002:
        $msg = '用户受限，可能是违规后接口被封禁';
        break;
      case 61451:
        $msg = '参数错误(invalid parameter)';
        break;
      case 61452:
        $msg = '无效客服账号(invalid kf_account)';
        break;
      case 61453:
        $msg = '客服帐号已存在(kf_account exsited)';
        break;
      case 61454:
        $msg = '客服帐号名长度超过限制(仅允许10个英文字符，不包括@及@后的公众号的微信号)';
        break;
      case 61455:
        $msg = '客服帐号名包含非法字符(仅允许英文+数字)';
        break;
      case 61456:
        $msg = '客服帐号个数超过限制(10个客服账号)';
        break;
      case 61457:
        $msg = '无效头像文件类型';
        break;
      case 61450:
        $msg = '系统错误';
        break;
      case 61500:
        $msg = '日期格式错误';
        break;
      case 65301:
        $msg = '不存在此menuid对应的个性化菜单';
        break;
      case 65302:
        $msg = '没有相应的用户';
        break;
      case 65303:
        $msg = '没有默认菜单，不能创建个性化菜单';
        break;
      case 65304:
        $msg = 'MatchRule信息为空';
        break;
      case 65305:
        $msg = '个性化菜单数量受限';
        break;
      case 65306:
        $msg = '不支持个性化菜单的帐号';
        break;
      case 65307:
        $msg = '个性化菜单信息为空';
        break;
      case 65308:
        $msg = '包含没有响应类型的button';
        break;
      case 65309:
        $msg = '个性化菜单开关处于关闭状态';
        break;
      case 65310:
        $msg = '填写了省份或城市信息，国家信息不能为空';
        break;
      case 65311:
        $msg = '填写了城市信息，省份信息不能为空';
        break;
      case 65312:
        $msg = '不合法的国家信息';
        break;
      case 65313:
        $msg = '不合法的省份信息';
        break;
      case 65314:
        $msg = '不合法的城市信息';
        break;
      case 65316:
        $msg = '该公众号的菜单设置了过多的域名外跳（最多跳转到3个域名的链接）';
        break;
      case 65317:
        $msg = '不合法的URL';
        break;
      case 85009:
        $msg = '已经有正在审核的版本';
        break;
      case 85010:
        $msg = 'item_list 有项目为空';
        break;
      case 85011:
        $msg = '标题填写错误';
        break;
      case 85012:
        $msg = '无效的审核 id';
        break;
      case 85052:
        $msg = '小程序已经发布';
        break;
      case 9001001:
        $msg = 'POST数据参数不合法';
        break;
      case 9001002:
        $msg = '远端服务不可用';
        break;
      case 9001003:
        $msg = 'Ticket不合法';
        break;
      case 9001004:
        $msg = '获取摇周边用户信息失败';
        break;
      case 9001005:
        $msg = '获取商户信息失败';
        break;
      case 9001006:
        $msg = '获取OpenID失败';
        break;
      case 9001007:
        $msg = '上传文件缺失';
        break;
      case 9001008:
        $msg = '上传素材的文件类型不合法';
        break;
      case 9001009:
        $msg = '上传素材的文件尺寸不合法';
        break;
      case 9001010:
        $msg = '上传失败';
        break;
      case 9001020:
        $msg = '帐号不合法';
        break;
      case 9001021:
        $msg = '已有设备激活率低于50%，不能新增设备';
        break;
      case 9001022:
        $msg = '设备申请数不合法，必须为大于0的数字';
        break;
      case 9001023:
        $msg = '已存在审核中的设备ID申请';
        break;
      case 9001024:
        $msg = '一次查询设备ID数量不能超过50';
        break;
      case 9001025:
        $msg = '设备ID不合法';
        break;
      case 9001026:
        $msg = '页面ID不合法';
        break;
      case 9001027:
        $msg = '页面参数不合法';
        break;
      case 9001028:
        $msg = '一次删除页面ID数量不能超过10';
        break;
      case 9001029:
        $msg = '页面已应用在设备中，请先解除应用关系再删除';
        break;
      case 9001030:
        $msg = '一次查询页面ID数量不能超过50';
        break;
      case 9001031:
        $msg = '时间区间不合法';
        break;
      case 9001032:
        $msg = '保存设备与页面的绑定关系参数错误';
        break;
      case 9001033:
        $msg = '门店ID不合法';
        break;
      case 9001034:
        $msg = '设备备注信息过长';
        break;
      case 9001035:
        $msg = '设备申请参数不合法';
        break;
      case 9001036:
        $msg = '查询起始值begin不合法';
        break;
      default:
        $msg = '未知错误码:' + errcode;
        break;

    }
    return $msg;
  }
}

export default utils



// WEBPACK FOOTER //
// ./src/utils/utils.js